@if (eyebrow) {
  <p class="eyebrow">{{ eyebrow }}</p>
}
<h2 [innerHTML]="title" class="title" [class.italic]="italic" [class.invert]="invert"></h2>
@if (subtitle) {
  <p class="subtitle">{{ subtitle }}</p>
}
